// extracted by mini-css-extract-plugin
export var carrierIcon = "_y6-0";
export var carrierLogo = "_y6-1";
export var detailsSection = "_y6-2";